import { useState } from 'react';
import { generateAndDownloadCard } from '../utils/cardGenerator';

/**
 * مكون لتوليد وتنزيل بطاقة المستخدم
 */
function CardGenerator({ user, schoolName, expiryDate, onGenerateComplete }) {
  const [isGenerating, setIsGenerating] = useState(false);
  const [error, setError] = useState(null);

  const handleGenerateCard = async () => {
    if (!user) {
      setError('بيانات المستخدم غير متوفرة');
      return;
    }

    setIsGenerating(true);
    setError(null);

    try {
      const userName = user.userName || user.fullName || user.name || 'اسم المستخدم';
      const userIdNumber = user.userIdNumber || 'XXXXX';
      const userImage = user.userImage || user.profileImage || user.image || null;
      const userGender = user.userGender !== undefined ? user.userGender : null;

      const userData = {
        userName,
        schoolName: schoolName || 'اسم المدرسة',
        userIdNumber,
        userImage,
        userGender,
        expiryDate: expiryDate || null,
      };

      const fileName = `card-${userIdNumber}-${userName.replace(/\s+/g, '-')}`;
      
      await generateAndDownloadCard(userData, fileName);
      
      if (typeof onGenerateComplete === 'function') {
        onGenerateComplete();
      }
    } catch (err) {
      console.error('خطأ في توليد البطاقة:', err);
      setError('تعذر توليد البطاقة. الرجاء المحاولة مرة أخرى.');
    } finally {
      setIsGenerating(false);
    }
  };

  return (
    <div className="card-generator">
      <button
        type="button"
        className="icon-button"
        onClick={handleGenerateCard}
        disabled={isGenerating}
        title="تنزيل بطاقة المستخدم"
        aria-label="تنزيل بطاقة المستخدم بصيغة PNG"
      >
        {isGenerating ? '⏳' : '🎫'}
      </button>
      {error && <span className="error-text" style={{ fontSize: '12px', color: 'red' }}>{error}</span>}
    </div>
  );
}

export default CardGenerator;

